<div [ngClass]="isReadOnly ? 'readonly-mode' : 'edit-mode'" *transloco="let t; read: 'building.assessment.protectiveMeasuresForm'">
  <form class="measure-card" [formGroup]="measureForm">
    @if (isEditionMode && !readOnly) {
    <span class="title" data-testid="modification-text">
      <mat-icon>mode_edit</mat-icon>
      <p>{{ t('modification') }}</p>
    </span>
    }
    <mat-label>{{ t('choseType') }}</mat-label>
    <mat-chip-listbox>
      @for (measureType of measureTypes$ | async; track measureType) {
      <mat-chip-option
        selectable
        (click)="onMeasureTypeSelected(measureType)"
        [class.selected]="isMeasureTypeSelected(measureType.id)"
        [disabled]="isMeasureTypeSelected(measureType.id) || readOnly"
      >
        @if (isMeasureTypeSelected(measureType.id)) {
        <mat-icon matChipAvatar>check</mat-icon>
        }
        {{ t('ref_measure.' + measureType.text) }}
      </mat-chip-option>
      }
    </mat-chip-listbox>
    <mat-form-field>
      <mat-label>{{ t('description') }}</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
    <mat-form-field class="proposition-improve">
      <mat-label>{{ t('proposition') }}</mat-label>
      <textarea
        data-testid="propositionImprove-field"
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="10"
        formControlName="proposition"
        (keyup)="extendTextArea($event.target)"
      >
      </textarea>
    </mat-form-field>
  </form>
  @if (!isReadOnly) {
  <sibat-validate-button
    data-testid="validate-changes-button"
    (clicked)="saveMeasure()"
    [label]="t('save')"
    [disabled]="measureForm.pristine"
  >
  </sibat-validate-button>
  }
</div>
